import React, { createContext, useEffect, useState } from 'react'
import {
  ReportFilterApplied,
  ReportFilterValues,
  ReportFilterSection,
  ReportFilterSettings,
  ReportFilterStat,
  ReportFilterContextData,
  ReportPageFilterSettings,
  ReportPageMultiFileFilterSettings,
} from './types'
import { useReport } from '../../hooks'
import { useURLSearchParam } from 'app/modules/shared'

export const reportFilterContext = createContext<ReportFilterContextData>(undefined as any)

export function WithReportFilterContext({ children }: { children: JSX.Element }): JSX.Element | null {
  const [isFilterActive, setFilterActive] = useState(false)
  const [filterSettings, setFilterSettings] = useState<ReportFilterSettings>()
  const [filterValues, setFilterValues] = useState<ReportFilterApplied>()
  const { subpage } = useReport()
  const clearFilter = useURLSearchParam('clearFilter')

  useEffect(() => {
    if (clearFilter === '1' || clearFilter === 'true') {
      setPageFilterValues({})
    }
  }, [subpage, clearFilter])

  // Shorthand for interacting with filter from page controller
  const init = (sections: ReportFilterSection[], stat: ReportFilterStat, defaults?: ReportFilterValues) => {
    if (!subpage) {
      return
    }

    const settings = { ...filterSettings }
    settings[subpage] = { sections, stat, defaults }

    setFilterSettings(settings)
  }

  // Shorthand for interacting with filter from page controller
  const initNew = (pageSettings: ReportPageFilterSettings | ReportPageMultiFileFilterSettings) => {
    if (!subpage) {
      return
    }

    const settings = { ...filterSettings }
    settings[subpage] = { ...pageSettings }

    setFilterSettings(settings)
  }

  // Get applied filter for specific page
  const getValues = (): ReportFilterValues => {
    return getPageData(filterValues, subpage) as ReportFilterValues
  }

  // Get settings for specific page
  const getFilterSettings = (): ReportPageFilterSettings | ReportPageMultiFileFilterSettings => {
    return getPageData(filterSettings, subpage) as ReportPageFilterSettings
  }

  const setPageFilterValues = (values: ReportFilterValues) => {
    if (!subpage) {
      return
    }

    const applied = { ...filterValues }
    applied[subpage] = values

    setFilterValues(applied)
  }

  const isFilterApplied = () => {
    const values = getValues()

    for (const sectionName in values || {}) {
      if (Array.isArray(values[sectionName]) && values[sectionName].length) {
        return true
      }
    }

    return false
  }

  const provided: ReportFilterContextData = {
    // pass to report page
    init, // DEPRECATED, should be replaced by initNew
    initNew,
    getValues,
    isFilterActive,

    // pass to filter component
    getFilterSettings,
    setValues: setPageFilterValues,
    setFilterActive,

    // pass to in-page filter button
    isFilterApplied,
  }

  return <reportFilterContext.Provider value={provided}>{children}</reportFilterContext.Provider>
}

function getPageData(allData: ReportFilterApplied | ReportFilterSettings | undefined, subpage: string | undefined) {
  const exists = subpage && allData && typeof allData[subpage] !== 'undefined'
  return exists ? allData[subpage] : undefined
}
